import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Styles = styled.div``;

const SelectMotivoBajaTk = ({id, value, onChange, isInvalid, isClearable,nivelAdmTk,isDisabled}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const motivoBajaTk = useSelector(state => state.default.motivoBajaTk);

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        setItems(motivoBajaTk);
    }, [motivoBajaTk]);
    useEffect(() => {
        let filtro = items;
        if(nivelAdmTk){
            filtro = items.filter((it)=>it.nivelAdmId_mbtk === nivelAdmTk)
        }
        const newOptions = filtro.map((item) => {
            return {
                value: item.id_mbtk,
                label: item.nombre_mbtk
            };
        });
        setOptions(newOptions);
        if (typeof value === 'string' || typeof value === 'number') {
            setSelectedValue(
                newOptions.find((opt) => opt.value === Number(value))
            );
        } else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>({label:va.nombre_mbtk,value:va.id_mbtk})));
        }else{
            setSelectedValue(null);
        }
    }, [items,nivelAdmTk])
    return (
        <Styles>
            <Select
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
                isDisabled={isDisabled}
            />
        </Styles>
    );
};

SelectMotivoBajaTk.defaultProps = {
    isClearable: false
};

export default SelectMotivoBajaTk;
